module.exports = __webpack_public_path__ + "static/media/8_r_stul_62.29_85.28.789d2392.png";